
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bitbucketAvatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"experimentalFeatures"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fetchedPullRequestsProgress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fetchedRepositoriesProgress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ghaInstallations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allRepositories"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"suspended"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gitlabAvatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"largestOrganization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timezoneId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newsletterEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"otherEmailsEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weeklyReportEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annuallyPayment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expirationISODate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isOwner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"licencesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"licencesDebt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stripeSubscription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionStartISODate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trialExpirationISODate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceCampaign"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vcs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skipTaskOrganisationInvite"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":940}};
    doc.loc.source = {"body":"mutation updateUserEmail($email: String!) {\n  updateUserEmail(email: $email) {\n    # ToDo: we should use fragments here\n    avatar\n    bitbucketAvatar\n    displayName\n    email\n    experimentalFeatures\n    fetchedPullRequestsProgress\n    fetchedRepositoriesProgress\n    gha\n    ghaInstallations {\n      allRepositories\n      installationId\n      login\n      suspended\n      type\n    }\n    gitlabAvatar\n    id\n    largestOrganization {\n      organizationId\n      users\n    }\n    timezoneId\n    newsletterEnabled\n    otherEmailsEnabled\n    weeklyReportEnabled\n    plan {\n      annuallyPayment\n      expirationISODate\n      id\n      isOwner\n      licencesCount\n      licencesDebt\n      name\n      organizationId\n      paymentStatus\n      price\n      stripeCustomer\n      stripeSubscription\n      subscriptionStartISODate\n      trialExpirationISODate\n      type\n    }\n    sourceCampaign\n    username\n    vcs\n    skipTaskOrganisationInvite\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["updateUserEmail"] = oneQuery(doc, "updateUserEmail");
        
